export default __webpack_public_path__ + "static/media/LimaDeclaration.f52d36e0.PDF";